﻿import { defineComponent } from 'vue';

import trip_summary from "../common/trip_summary.vue";
import itinerary_breakdown from "../common/itinerary_breakdown.vue";

import { booking_group } from "../../../objects/v1_2/Booking/Booking_Group"
import { booking_info } from "../../../objects/v1_2/Booking_Details/booking_info";
import { age_cat } from "../../../objects/v1_3/web_engine/age_cat"

import { Booking } from "../../../services/booking";
import { Product } from "../../../services/product";
import { Web_Engine } from "../../../services/web_engine"

import { Currency_Service } from "../../../../system/services/currency";
import { stringifyQuery } from "vue-router";
import { Room } from "../../../services/room";

const Book = new Booking();
const Prod = new Product();
const Web = new Web_Engine();
const Currency_Services = new Currency_Service();
const Service_Room = new Room();

class GooglePassengerDetail {
    public age_cat: string = "";
    public count: number = 0;
    public price: number = 0;
}

export default defineComponent({
    name: "basket",
    emits: [
        "Add_To_Cart"
    ],
    components: {
        trip_summary,
        itinerary_breakdown
    },
    props: {
        trip_index: Number,
        tour_id: String
    },
    data() {
        return {
            age_cat: new age_cat(),
            passenger: 0,
            open: false
        }
    },
    methods: {
        async download_passenger() {
            this.age_cat = await Web.Get_Passengers();

            this.age_cat.categories = this.age_cat.categories.sort((first, second) => {
                return 0 - (first.name > second.name ? -1 : 1)
            });
        },
        get_Basket(): booking_group {
            return this.$store.getters.get_Basket;
        },
        isBookable(): boolean {

            let Quote_Basket: booking_group = this.get_Basket();
            let productDetails = Prod.Get_Details_Sync(this.get_Booking_Trip()?.tour_id, this.$store);
            let roomlength = 0;

            if(Prod.getRoundedDays(productDetails.operational_information?.duration) > 1){
                let productDetails = Prod.Get_Details_Sync(this.get_Booking_Trip()?.tour_id, this.$store);
                if(Quote_Basket.trips[this.get_Trip_Index()]?.rooms != null){
                    roomlength = Quote_Basket.trips[this.get_Trip_Index()]?.rooms.length;
                }
                if(Service_Room.get_Room_List(productDetails, this.$store).length == 0){
                    roomlength = 1;
                }
            }
            else{
                roomlength = 1;
            }
            
            if (roomlength > 0 && this.has_Quote() && Quote_Basket?.passengers?.length > 0 && Quote_Basket?.trips[this.get_Trip_Index()]?.tour_id != null && Quote_Basket?.trips[this.get_Trip_Index()]?.departure_date != null && Book.get_total_price(this.$store.getters.get_Booking, this.$store) > 0) {
                return true;
            }

            return false;
        },
        async Booking_Trip() {
            let booking_info = await Book.Book_Trip(this.$store).then(response => { return response.json(); });

            if (booking_info.group_booking_id > 0) {
                this.$store.commit("Setup_Booking", { Booking_Details: booking_info });
                this.$router.push("/booking/" + booking_info.group_booking_id);
            } else {
                this.$store.getters.get_Basket.trips.forEach(trip => {
                    if(trip.rooms == null || trip.rooms.length == 0 || trip.rooms == undefined){
                        booking_info.booking_error = "Unfortunately, the tour appears to be fully booked. Please consider alternative dates or contact us for assistance."
                    }
                });
                alert("Basket " + booking_info.booking_error);
            }
        },
        available_spaces(): number {
            return this.$store.getters.get_seats_free_selected_date;
        },
        Add_To_Cart() {
            if(this.get_passangers().toUpperCase().includes("CHILD")){
                if(!this.get_passangers().includes("Adult") && !this.get_passangers().includes("Senior") && !this.get_passangers().includes("Student")){
                    alert("You need to have at least one 18+ member in the group");
                    return;
                }
            }
            // Was "get_total_price(...), get_Currency < 1" (comma operator), so this check never fired.
            if (Book.get_total_price(this.$store.getters.get_Booking, this.$store) < 1) {
                alert("Sorry, an error has occurred, trip failed to add");
                return;
            }
            if(this.available_spaces() < this.$store.getters.get_Booking?.trips[0]?.passengers.length)
            {
                alert("Sorry, there are not enough seats available for the selected passengers");
                return;
            }

            this.$emit("Add_To_Cart");
            this.gtag_add_to_cart();
        },

        get_passangers(): string {
            return Book.Passenger_Details(false, this.age_cat, this.get_Booking_Trip()?.tour_id, this.$store.getters.get_Booking);
        },
        gtag_get_item(index: number, paxType: string, paxCount: number, paxPrice: number) {

            let tour_id = this.get_Booking_Trip()?.tour_id;
            let lengthCategory = "1 Day Tours";
            if(parseInt(Prod.product_durationInDays(Prod.Get_Details_Sync(tour_id, this.$store)).replace(" days", "").replace(" day", "")) > 1){
                lengthCategory = "3-8 Day Tours";
            }

            let product_details = Prod.Get_Details_Sync(tour_id, this.$store);

            var item = {
                item_id: tour_id,
                item_name: product_details.name,
                affiliation: import.meta.env.VITE_DEFAULT_TAB_TEXT + " Booking Engine",
                coupon: this.get_Booking_Trip()?.promo_code,
                index: index,
                item_brand: import.meta.env.VITE_DEFAULT_TAB_TEXT,
                item_category: Prod.product_durationInDays(product_details),
                item_category2: lengthCategory,
                item_category3: Prod.product_start_location(product_details),
                item_category4: paxType,
                item_list_name: lengthCategory,
                price: paxPrice,
                quantity: paxCount
            };

            return item;
        },
        
        gtag_add_to_cart() {

            var allItems: [] = [];
            var index = 0;
            var totalAmount = 0;
            var GooglePassengerDetails: GooglePassengerDetail[] = [];


            var trip = this.get_Booking_Trip()

            trip?.passengers?.forEach(pax => {
                let passengerAge = Book.get_Passenger_Age_Cat(pax.passenger_identifier, this.$store.getters.get_Booking);
                totalAmount += pax.price;

                if(GooglePassengerDetails.findIndex(f => f.age_cat == passengerAge) == -1){
                    GooglePassengerDetails.push({age_cat: passengerAge, count: 1, price: pax.price});
                }
                else{
                    let index_location = GooglePassengerDetails.findIndex(f => f.age_cat == passengerAge);
                    GooglePassengerDetails[index_location].count++;
                    GooglePassengerDetails[index_location].price = pax.price;
                }

            });

            GooglePassengerDetails.forEach(pax => {
                allItems.push(this.gtag_get_item(index, pax.age_cat, pax.count, pax.price));
                index++;
            });


            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: this.$store.getters.get_Currency.currency_info.iso_currency_code,
                    value: totalAmount,
                    items: allItems
                }
            });
        },
        get_Total(): string {
            return Currency_Services.Format_Currency(Book.get_total_price(this.$store.getters.get_Booking, this.$store), this.$store.getters.get_Currency);
        },
        get_Quote_Trip(): booking_info | null {
            const trips = this.$store.getters.get_Booking?.trips;
            const tripIndex = this.get_Trip_Index_By_Tour_Id(this.tour_id);
            if (!trips || !Array.isArray(trips) || !trips[tripIndex]) {
                return null;
            }
            return trips[tripIndex];
        },
        has_Quote(): boolean {
            //the price only comes from a quote for the current tour, departure date and passengers, not a previous one kept in the session
            let Basket_Trip = this.get_Basket()?.trips[this.get_Trip_Index()];
            let Quote_Trip = this.get_Quote_Trip();

            if (Basket_Trip == null || Quote_Trip == null || !Basket_Trip.departure_date || !(this.get_Basket()?.passengers?.length > 0)) {
                return false;
            }

            if (Quote_Trip.tour_id != Basket_Trip.tour_id || !this.is_Same_Date(Quote_Trip.departure_date, Basket_Trip.departure_date)) {
                return false;
            }

            if (this.needs_Room_Selection()) {
                return false;
            }

            return Book.get_price(Quote_Trip) > 0;
        },
        needs_Room_Selection(): boolean {
            return Book.Trip_Needs_Room(this.get_Basket()?.trips[this.get_Trip_Index()], this.$store);
        },
        show_Room_Message(): boolean {
            let Basket_Trip = this.get_Basket()?.trips[this.get_Trip_Index()];
            return !!Basket_Trip?.departure_date && this.get_Basket()?.passengers?.length > 0 && this.needs_Room_Selection();
        },
        is_Same_Date(date1: string | null, date2: string | null): boolean {
            //quote dates are yyyy-mm-dd..., basket dates are yyyy/m/d
            let Parts1 = (date1 ?? "").match(/(\d{4})\D(\d{1,2})\D(\d{1,2})/);
            let Parts2 = (date2 ?? "").match(/(\d{4})\D(\d{1,2})\D(\d{1,2})/);
            if (Parts1 == null || Parts2 == null) {
                return true; //unknown format, don't hide the price on it
            }

            return Number(Parts1[1]) == Number(Parts2[1]) && Number(Parts1[2]) == Number(Parts2[2]) && Number(Parts1[3]) == Number(Parts2[3]);
        },
        get_Trip_Total_Price(): number {
            let Quote_Trip = this.get_Quote_Trip();
            return Quote_Trip == null ? 0 : Book.get_price(Quote_Trip);
        },
        get_Trip_Total(): string {
            return Currency_Services.Format_Currency(this.get_Trip_Total_Price(), this.$store.getters.get_Currency);
        },
        has_Base_Price(): boolean {
            //shown as base price + chosen room price = total once a room is chosen
            return this.has_Quote() && this.has_Room_Selected() && this.get_Base_Price_Number() > 0;
        },
        get_Base_Price_Number(): number {
            let productDetails = Prod.Get_Details_Sync(this.get_Basket()?.trips[this.get_Trip_Index()]?.tour_id ?? "", this.$store);
            return Service_Room.get_Base_Price(productDetails, this.get_Trip_Index(), this.$store);
        },
        get_Base_Price(): string {
            return Currency_Services.Format_Currency(this.get_Base_Price_Number(), this.$store.getters.get_Currency);
        },
        has_Room_Selected(): boolean {
            return this.get_Basket()?.trips[this.get_Trip_Index()]?.rooms?.length > 0;
        },
        get_Room_Name(): string {
            let Room_Names: string[] = [];
            this.get_Basket()?.trips[this.get_Trip_Index()]?.rooms?.forEach(room => {
                if (room.room_type && !Room_Names.includes(room.room_type)) {
                    Room_Names.push(room.room_type);
                }
            });

            return Room_Names.length > 0 ? Room_Names.join(", ") : "Accommodation";
        },
        get_Room_Price(): string {
            //the room price is the remainder of the quoted total so base + room always adds up to the total
            let Difference: number = this.get_Trip_Total_Price() - this.get_Base_Price_Number();
            let return_price_string = Currency_Services.Format_Currency(Difference, this.$store.getters.get_Currency);

            return (Difference < 0) ? return_price_string : "+ " + return_price_string;
        },
        get_Curreny_Code() {
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        get_Booking_Summary() {
            let Output: string = "";

            let productDetails = Prod.Get_Details_Sync(this.get_Booking_Trip()?.tour_id, this.$store);

            Output += Prod.product_duration_information_rounded(productDetails) + " " + Prod.product_overnight_rounded_duration(productDetails.operational_information.duration);
            Output += " for " + Book.Passenger_Details(false, this.age_cat, this.get_Booking_Trip()?.tour_id, this.$store.getters.get_Booking);

            if (this.get_Booking_Trip()?.reservation_rooms?.length > 0) {
                Output += " incl. accommodation";
            }

            return Output + ".";
        },
        get_Trip_Index(): number {
            return this.trip_index ?? 0;
        },
        // the quote's trip for this basket trip: the quote also lists the add-ons as trips, so it's matched on the tour
        // rather than on get_Trip_Index() (which indexes get_Basket.trips)
        get_Booking_Trip(): any {
            const tour_id = this.get_Basket()?.trips?.[this.get_Trip_Index()]?.tour_id;
            return (this.$store.getters.get_Booking?.trips ?? []).find((Trip: any) => Trip.tour_id == tour_id);
        },
        get_Trip_Index_By_Tour_Id(tour_id?: string): number {
            if (!tour_id) {
                return this.get_Trip_Index();
            }

            const trips = this.$store.getters.get_Booking?.trips;
            if (!trips || !Array.isArray(trips)) {
                return this.get_Trip_Index();
            }

            const matchingIndex = trips.findIndex(trip => trip?.tour_id === tour_id);
            return matchingIndex >= 0 ? matchingIndex : this.get_Trip_Index();
        }
    },
    mounted() {
        this.download_passenger();
    }
})